import pure from "./higher-order/pure";
import React from "react";

export default pure(function TournamentListHeader() {
  return (
    <div className="tournament-table tournament-table--header">
      <div className="tournament-table_row batch-g batch-g--padding batch-g--valign-center">
        <div className="batch-c-1-2">
          <a className="tournament-table_sort">
            Tournaments
          </a>
        </div>

        <div className="batch-c-1-10">
          <span className="tournament-table_sort">
            Prize
          </span>
        </div>

        <div className="batch-c-1-10">
          <span className="tournament-table_sort">
            Entry
          </span>
        </div>

        <div className="batch-c-1-12">
          <span className="tournament-table_sort">
            Players
          </span>
        </div>

        <div className="batch-c-1-8">
          <span className="tournament-table_sort">
            Closes
          </span>
        </div>
      </div>
    </div>
  );
});
